import React, { useEffect, useState } from 'react'
import { Button, DialogContainer, Chip, Checkbox, SelectionControl } from 'react-md'
import styles from '../../css/styles.css.js';
import ApiRequestService from '../../component/ApiRequestService.js';
import LoadingSpinner from '../../component/LoadingSpinner.js';
import SFForm from '../../component/sf-form/SFForm.js';

function StudentModal({ showDialog, handleHide, onAddStudentComplete, onUpdateStudentComplete, data, fields, 
  courseID, sectionID, course_name, section_name }) {

  const [user, setUser] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formFields, setFormFields] = useState(fields);
  const [emailStudentChecked, setEmailStudentChecked] = useState(true);

  const isFieldValid = (field) => {
    const fieldId = field.id;

    const fieldValue = user[fieldId];

    if (typeof field.validate === 'function') {
      const validation = field.validate(fieldValue);
      if (validation !== "") {
        setErrorMessage(`Validation error for ${field.name}: ${validation}`)
        console.log(`Validation error for ${field.name}: ${validation}`);
        return false;
      }
    }
    if (field.defaultValue || (user.hasOwnProperty(fieldId) && // Check if the field exists in the user object
      user[fieldId] !== null && // Check if the field value is not null
      user[fieldId] !== undefined && // Check if the field value is not undefined
      String(user[fieldId]).trim() !== '')) { // Check if the field value is not an empty string
      return true
    }
    setErrorMessage("Please fill out all the required (*) fields");
    return false;
  }

  useEffect(() => {
    console.debug("data", data)
    if (data && Object.keys(data).length > 0) {
      setUser(data)
      setEditMode(true)
      let updateFormFields = formFields.map(field => {
        if (field.id === "email_id") {
          return {...field, disabled: true}
        }
        return field;
      })
      console.debug("updateFormFields>>" ,updateFormFields)
      setFormFields(updateFormFields);
    } else {
      let newUser = {}
      if (formFields) {
        formFields.forEach(field => {
          newUser[field.id] = null
        })
      }
      console.debug("newUser", newUser, formFields)
      setUser(newUser);
      setEditMode(false);
      setFormFields(fields);
    }
    setErrorMessage(null);
  }, [data, showDialog]);


  const handleAdd = (data, editMode) => {
    console.debug("data, editMode", data, editMode)
    
    var course_id = parseInt(courseID, 10);
    if (sectionID) {
      var section_id = parseInt(sectionID, 10);
      data.section_id = section_id;
    }
    
    let payload = {
      ...data,
      course_id: course_id
    }

    console.debug("payload>>", payload)

    setLoading(true);

    if (editMode) {
      ApiRequestService({
        method: 'post',
        url: '/updateStudentByInstructor',
        data: payload
      }).then(res => {
        console.debug("updateStudent res", res)
        if (res && res.data && res.data.status === 0) {
          onUpdateStudentComplete(payload)
        } else {
          setErrorMessage(res.data.message)
        }
      }).finally(() => {
        setLoading(false);
      })
    } else {
      ApiRequestService({
        method: 'post',
        url: '/addStudentByInstructor',
        data: {
          ...payload,
          course_name, 
          section_name,
          email_student: emailStudentChecked
        }
      }).then(res => {
        if (res && res.data && res.data.status === 0) {
          onAddStudentComplete(res.data.data)
        } else {
          setErrorMessage(res.data.message)
        }
      }).finally(() => {
        setLoading(false);
      })
    }

    
  }



  let button = (
    <Button style={styles.addButton} onClick={() => {
      setErrorMessage(null)
      console.debug("user", user);
      const allFieldsValid = formFields.every(field => field.isRequired ? isFieldValid(field) : true);
      if (allFieldsValid) {
        handleAdd(user, editMode);
      }
    }}>
      {editMode ? "Edit" : "Add"}
    </Button>
  );
  var cancelButton = (
    <Button style={styles.cancelButton} onClick={handleHide}>
      Cancel
    </Button>
  );


  const actions = [];
  actions.push(button);
  actions.push(cancelButton);

  const handleFormChange = (fieldID, value) => {
    setUser(user => ({
      ...user,
      [fieldID]: value
    }));
  }

  return (
    <div>
      <DialogContainer
        id="add-student-dialog"
        style={{
          textAlign: "left",
        }}
        width={800}
        title={`${editMode ? "Edit" : "Add"} student`}
        visible={showDialog}
        modal
        focusOnMount={false}
        onHide={handleHide}
        actions={actions}
      >
        <div>
          {errorMessage ?
            <Chip label={errorMessage} />
            : null}
          
          {loading ? 
          <div style={{
            position: 'absolute',
            width:'100%',
            height:'100%',
            zIndex: 2,
            background:'rgba(255, 255, 255, 0.5)',
            padding:'0',
            margin:'0',
            top:'0',
            left:'0'

          }}>
            <LoadingSpinner loading={loading} />
          </div>
          : null}
          
          
            <SFForm 
              fields={formFields} 
              data={user} 
              height='fit-content' 
              handleFormChange={handleFormChange} 
            />  
          
          {!editMode ? 
            <SelectionControl
              id="email-student"
              name="email-student"
              label="Email student when added"
              type="checkbox"
              value="documentation"
              checked={emailStudentChecked}
              onChange={val => {
                setEmailStudentChecked(val);
              }}
            />
          : null}
          
        </div>
      </DialogContainer>
    </div>
  );
}

export default StudentModal;
